"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Objeto = void 0;
var Objeto = /** @class */ (function () {
    function Objeto(id, texto, fila, columna, listaAtributos, listaObjetos) {
        this.identificador = id;
        this.texto = texto;
        this.fila = fila;
        this.columna = columna;
        this.listaAtributos = listaAtributos;
        this.listaObjetos = listaObjetos;
    }
    return Objeto;
}());
exports.Objeto = Objeto;
